import React, { useEffect, useState } from 'react'
import MUIDataTable from "mui-datatables";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
// import { createTheme, ThemeProvider } from "@mui/material/styles";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import RoleTable from '../../components/750/RoleTable';
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import styled from '@emotion/styled';
import axios from '../../api/PrivateApi'

const muiCache = createCache({
  "key": "mui",
  "prepend": true
});

const columns = [
  {
    label: "First Name",
    name: "first_name",
    options: {
      filter: false,
      sort: true,
    },
  },
  {
    label: "Middle Name",
    name: "middle_name",
    options: {
      filter: false,
      sort: true,
    },
  },
  {
    label: "Last Name",
    name: "last_name",
    options: {
      filter: false,
      sort: true,
    },
  },
  {
    label: "Phone No.",
    name: "mobile",
    options: {
      filter: false,
    },
  },
  {
    label: "Email",
    name: "email",
    options: {
      filter: true,
    },
  },
  {
    label: "Staff_ID",
    name: "Staff",
    options: {
      display: false,
    }
  }
];

const options = {
  selectableRows: false,
  filter: true,
  filterType: "dropdown",
  responsive: "standard",
  expandableRows: true,
  expandableRowsHeader: false,
  expandableRowsOnClick: true,
  rowsPerPage: 6,
  rowsPerPageOptions: [6, 10, 20, 40],
  isRowExpandable: (dataIndex, expandedRows) => {
    // Prevent expand/collapse of any row if there are 2 rows expanded already (but allow those already expanded to be collapsed)
    if (
      expandedRows.data.length > 0 &&
      expandedRows.data.filter((d) => d.dataIndex === dataIndex).length === 0
    )
      return false;
    return true;
  },
  renderExpandableRow: (rowData, rowMeta) => {
    const colSpan = rowData.length + 1;
    return (
      <TableRow>
        <TableCell colSpan={colSpan}>
          {console.log('staffsmyy: ', rowData[5].id)}
          <RoleTable staffId={rowData[5].id} />
        </TableCell>
      </TableRow >
    );
  },
  onRowExpansionChange: (curExpanded, allExpanded, rowsExpanded) =>
    console.log(curExpanded, allExpanded, rowsExpanded),
};

const components = {
  ExpandMoreIcon: function (props) {
    return <ExpandMoreIcon {...props} />;
  },
};
const StyledMUIDataTable = styled(MUIDataTable)(({ theme }) => ({
  background: theme.palette.background.default,
  marginTop: '20px'
}))

function AdminRoleAuthPage() {
  const [data, setData] = useState([])

  useEffect(() => {
    const fetchData = async () => {
      const res = await axios(`roles/staffs`);
      console.log('staffs: ', res.data)
      setData(res.data)
    }

    fetchData()
  }, [])

  return (
    <CacheProvider value={muiCache}>
      <StyledMUIDataTable
        title={"User Role Authorization"}
        data={data}
        columns={columns}
        options={options}
        components={components}
      /></CacheProvider>
  )
}

export default AdminRoleAuthPage